import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import TableList from '../shared/TableList.js';
import EvidenceModal from '../shared/EvidenceModal.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages } from '@fortawesome/free-solid-svg-icons';

const formatAlertDate = (date) => {
    const d = new Date(Date.parse(date))
    const region = "es-CL"
    return `${d.toLocaleDateString(region)} ${d.toLocaleTimeString(region)}`
  }

export default function MaintanceTable({ maintance }) {
  const [showEvidenceModal, setShowEvidenceModal] = useState(false);
  const [selectedEvidence, setSelectedEvidence] = useState([]);

  const handleShowEvidence = (images) => {
    setSelectedEvidence(images);
    setShowEvidenceModal(true);
  };

  if(!maintance.length) {
    return (
      <div className="text-center text-muted py-4 my-4">No se encontraron mantenciones</div>
    )
  }
  return (
    <>
    <TableList>
      <TableList.Header>
        <TableList.HeaderItem value="Fecha" width={200} />
        <TableList.HeaderItem value="Usuario" width={150}/>
        <TableList.HeaderItem value="Tipo" width={150} />
        <TableList.HeaderItem value="Comentario" width={350} />
        <TableList.HeaderItem value="Evidencias" width={150} />
      </TableList.Header>

      <TableList.Body>
        {
          maintance.map(item => (
            <TableList.Row key={item.id}>
                <TableList.Column>
                    <Link to={`/reports/${item.id}`}>
                      { formatAlertDate(item.created_at) }
                    </Link>
                </TableList.Column>
                <TableList.Column >
                    {item.user_name}
                </TableList.Column>
                <TableList.Column>
                    {item.report_type}
                </TableList.Column>
                <TableList.Column>
                    <div
                      title={item.comments}
                      style={{
                        width: '350px',
                        minWidth: '350px',
                        maxWidth: '350px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {item.comments}
                    </div>
                </TableList.Column>
                <TableList.Column>
                    {item.images && item.images.length > 0 ? (
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => handleShowEvidence(item.images)}
                      >
                        <FontAwesomeIcon icon={faImages} className="mr-1" />
                        Ver evidencia ({item.images.length})
                      </button>
                    ) : (
                      <span className="text-muted">Sin evidencia</span>
                    )}
                </TableList.Column>
            </TableList.Row>
          ))
        }
      </TableList.Body>
    </TableList>

    {showEvidenceModal && (
      <EvidenceModal
        files={selectedEvidence}
        onClose={() => setShowEvidenceModal(false)}
      />
    )}
  </>
  )
}
